import { NextRouter, useRouter } from "next/router"
import React, { useEffect, useState } from "react"
import { LocalizedNews } from "../../../types/news"
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, Thumbs, Autoplay } from "swiper"
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"
// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { getNewsPageUrl } from "../../../utils/urls"
import * as ImageConstants from "../../../constants/images"
import { uniqueId } from "lodash"
import Image from "next/image"

function newsToMainSwiperSlide(router: NextRouter, news: any, isMobile: boolean) {
  return (
    <SwiperSlide
      key={uniqueId()}
      style={{
        width: "100%",
        position: "relative",
        textAlign: "center",
        color: "white",
      }}
    >
      <>
        <Image
          src={news.image?.path || ImageConstants.NEWS_MISSING_IMAGE_PATH}
          alt={news.title}
          layout={"intrinsic"}
          width={852}
          height={852}
        />
      </>
    </SwiperSlide>
  )
}

function newsToThumbsSwiperSlide(router: NextRouter, news: any) {
  return (
    <SwiperSlide
      key={uniqueId()}
      style={{
        width: "100%",
        position: "relative",
        textAlign: "center",
        color: "white",
      }}
    >
      <>
        <Image
          src={news.image?.path || ImageConstants.NEWS_MISSING_IMAGE_PATH}
          alt={news.title}
          layout={"intrinsic"}
          width={500}
          height={500}
        />
      </>
    </SwiperSlide>
  )
}

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Thumbs, Autoplay])

const IMAGES_SLIDER = [
  {
    id: 1,
    image: { path: "https://s3.eu-central-1.wasabisys.com/calcio-com/news/RPP_SERIE_A.jpg" },
  },
  {
    id: 2,
    image: { path: "https://s3.eu-central-1.wasabisys.com/calcio-com/news/RPP_PREMIER_LEAGUE.jpg" },
  },
  {
    id: 3,
    image: { path: "https://s3.eu-central-1.wasabisys.com/calcio-com/news/RPP_LALIGA.jpg" },
  },
  {
    id: 4,
    image: { path: "https://s3.eu-central-1.wasabisys.com/calcio-com/news/RPP_Bundesliga.jpg" },
  },
  {
    id: 5,
    image: { path: "https://s3.eu-central-1.wasabisys.com/calcio-com/news/RPP_Ligue1.jpg" },
  },
]

export default function NewsStaticCarouselRPP() {
  const router = useRouter()

  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore | null>(null)

  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    setIsMobile((typeof window !== "undefined" && window?.matchMedia("(max-width: 600px)")?.matches) || false)
  }, [])

  return (
    <>
      {IMAGES_SLIDER.length > 0 && (
        <>
          <Swiper
            spaceBetween={10}
            navigation={!isMobile}
            pagination={isMobile}
            thumbs={!isMobile ? { swiper: thumbsSwiper } : undefined}
            className="mainSwiperStaticRPP"
            autoplay={{ delay: 8000 }}
          >
            {newsToMainSwiperSlide(router, IMAGES_SLIDER[0], isMobile)}
            {IMAGES_SLIDER.slice(1).map((n) => {
              return newsToMainSwiperSlide(router, n, isMobile)
            })}
          </Swiper>
          {!isMobile && (
            <Swiper
              onSwiper={(swiper) => setThumbsSwiper(swiper)}
              spaceBetween={10}
              slidesPerView={5}
              freeMode={true}
              // watchSlidesVisibility={true}
              watchSlidesProgress={true}
              className="thumbsSwiper"
            >
              {IMAGES_SLIDER.map((n) => {
                return newsToThumbsSwiperSlide(router, n)
              })}
            </Swiper>
          )}
        </>
      )}
    </>
  )
}
